"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaletteManager = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _chainClient = require("@blockwell/chain-client");
var _PaletteRegistry = require("./PaletteRegistry");
var _BlockRegistry = require("./BlockRegistry");
var _spec = require("./spec");
var _remeda = require("remeda");
var _DumbappTracker = require("./dumbapp/DumbappTracker");
var _page = require("./page");
var _migrate = require("./spec/migrate");
var _variables = require("@blockwell/variables");
class PaletteManager {
  get root() {
    return Object.freeze({
      block: this.rootHolder.root
    });
  }
  get name() {
    return this.detailHolder.name;
  }
  set name(name) {
    this.detailHolder.name = name;
    this.registry.tracker.paletteName = name;
  }
  get schemaVersion() {
    return this.detailHolder.schemaVersion;
  }
  set schemaVersion(version) {
    this.detailHolder.schemaVersion = version;
  }
  get style() {
    return this.styleHolder.style;
  }
  set style(style) {
    this.styleHolder.style = style;
  }
  get color() {
    return this.colorHolder.color;
  }
  set color(color) {
    this.colorHolder.color = color;
  }
  get page() {
    return this.pageHolder.page;
  }
  constructor(name, schemaVersion, param, batches, nft, blockTypes, variableTypes, convertTypes) {
    /**
     * Holder is used so the PaletteManager instance can be frozen. This is to prevent Vue from
     * polluting the objects with reactivity, as that's handled internally.
     *
     * @private
     */
    (0, _defineProperty2.default)(this, "rootHolder", {
      root: null
    });
    (0, _defineProperty2.default)(this, "detailHolder", {
      name: "",
      schemaVersion: 0
    });
    (0, _defineProperty2.default)(this, "styleHolder", {
      style: null
    });
    (0, _defineProperty2.default)(this, "colorHolder", {
      color: null,
      recents: false
    });
    (0, _defineProperty2.default)(this, "pageHolder", {
      page: null
    });
    (0, _defineProperty2.default)(this, "registry", void 0);
    this.detailHolder.name = name;
    this.detailHolder.schemaVersion = schemaVersion;
    this.registry = new _PaletteRegistry.PaletteRegistry(new _BlockRegistry.BlockRegistry(blockTypes), variableTypes, new _chainClient.AbiRegistry(), batches, nft, new _DumbappTracker.DumbappTracker(name), convertTypes);
  }
  addRecentColor(color) {
    if (!this.colorHolder.recents) {
      let colors = this.style.findColors();
      this.color.addRecent(colors);
      this.colorHolder.recents = true;
    }
    this.color.addRecent(color);
  }
  getRecentColors(excludeTheme = true) {
    if (!this.colorHolder.recents) {
      let colors = this.style.findColors();
      this.color.addRecent(colors);
      this.colorHolder.recents = true;
    }
    return this.color.getRecent(10, excludeTheme);
  }
  activate() {
    this.rootHolder.root.context.activate();
  }
  setRoot(spec) {
    if (!spec.createCtx) {
      spec.createCtx = "root";
    }
    this.rootHolder.root = (0, _spec.addBlock)(spec, this.registry, undefined);
    this.rootHolder.root.context = new _variables.ContextManager(this.rootHolder.root.key, typeof spec.createCtx === "string" ? spec.createCtx : "root");
    this.registry.blocks.setRoot(this.rootHolder.root);
    this.rootHolder.root.context.attachAsRoot(this.registry.batches, this.registry.nft, this.registry.abis, this.registry.convertTypes, this.registry.parameters);
    return this.root;
  }
  setPages(param, spec) {
    var _this$pageHolder$page;
    (_this$pageHolder$page = this.pageHolder.page) === null || _this$pageHolder$page === void 0 ? void 0 : _this$pageHolder$page.destroy();
    this.pageHolder.page = new _page.PageRouter(this.registry, param, spec);
  }
  updateRootParameters(update) {
    this.registry.updateParameters(update);
  }
  destroy() {
    var _this$pageHolder$page2;
    this.registry.blocks.destroy();
    this.registry.events.clearListeners();
    (_this$pageHolder$page2 = this.pageHolder.page) === null || _this$pageHolder$page2 === void 0 ? void 0 : _this$pageHolder$page2.destroy();
    this.rootHolder.root = null;
  }
  toJSON() {
    let root = (0, _remeda.clone)(this.root.block.toJSON().block);
    (0, _migrate.traverseBlocks)({
      block: root
    }, block => {
      let children = block.block.children;
      if (block.block.children && block.block.children.length === 0) {
        delete block.block.children;
      }
      if (block.block.vars && block.block.vars.length === 0) {
        delete block.block.vars;
      }
      if (block.block.classes && block.block.classes.length === 0) {
        delete block.block.classes;
      }
      if ((children === null || children === void 0 ? void 0 : children.length) > 0) {
        return {
          children
        };
      }
      return {
        children: undefined
      };
    });
    return {
      name: this.name,
      schemaVersion: this.detailHolder.schemaVersion,
      param: (0, _remeda.clone)(this.pageHolder.page.param),
      root,
      pages: this.pageHolder.page.toJSON(),
      style: this.style.toJSON(),
      abis: this.registry.abis.toJSON(),
      colors: this.color.toJSON()
    };
  }
}
exports.PaletteManager = PaletteManager;
(0, _defineProperty2.default)(PaletteManager, "settings", [{
  title: "Palette Settings",
  settings: {
    title: {
      type: "editor",
      title: "Page Title",
      editor: "markdown",
      inline: true,
      single: true
    }
  }
}, {
  title: "",
  settings: {}
}]);
//# sourceMappingURL=PaletteManager.js.map